import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { TUITION_FEE_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { deleteStudentAction } from "../../../redux/actions/studentsActions";
import moment from "moment";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";

const TuitionFeeCompanyCard = ({
  mode,
  setOpenMoreModal,
  data,
  cellNumber,
}) => {
  const dispatch = useDispatch();
  const { contractTypesList } = useCustomHook();
  const { tuitionFeeData, lastPage } = useSelector(
    (state) => state.tuitionFeePagination,
  );
  const { tuitionFeeSearchValues } = useSelector((state) => state.searchValues);
  const { tuitionFeeModalLoading } = useSelector(
    (state) => state.tuitionFeeModal,
  );

  const updateItem = (modalType) => {
    dispatch({
      type: TUITION_FEE_MODAL_ACTION_TYPE.GET_TUITION_FEE_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
      },
    });
  };

  const deleteItem = () => {
    const pageNumber =
      lastPage > 1 ? (tuitionFeeData.length > 1 ? lastPage : lastPage - 1) : 1;
    const _id = data._id;
    const searchQuery = tuitionFeeSearchValues;
    const status = "all";
    dispatch(deleteStudentAction({ _id, pageNumber, searchQuery, status }));
  };

  const openConfirmModal = () => {
    dispatch({
      type: TUITION_FEE_MODAL_ACTION_TYPE.UPDATE_TUITION_FEE_PAYMENTS,
      payload: {
        data: data,
        openModal: false,
        openConfirmModal: true,
      },
    });
  };

  const openMoreModal = () => {
    updateItem("more");
    setOpenMoreModal(true);
  };

  const doubleClick = () => {
    if (!tuitionFeeModalLoading) {
      openConfirmModal();
    }
  };
  return (
    <tr onDoubleClick={doubleClick}>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {cellNumber}. {data?.companyName}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.directorFullName}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.companyVoen}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.bankName}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.correspondentAccount}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.bankVoen}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.bankCode}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.swift}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.settlementAccount}</div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {contractTypesList.find(
              (item) => item.key === data?.contract?.contractType,
            )?.name || ""}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {" "}
            {data?.contractEndDate
              ? moment(data.contractStartDate).locale("az").format("DD.MM.YYYY")
              : "" || ""}
          </div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {" "}
            {data?.contractEndDate
              ? moment(data.contractEndDate).locale("az").format("DD.MM.YYYY")
              : "" || ""}
          </div>
        </div>
      </td>{" "}
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {data?.paymentDate
              ? moment(data.paymentDate).locale("az").format("DD.MM.YYYY")
              : "" || ""}
          </div>
        </div>
      </td>{" "}
      <td
        style={
          data?.isPaid
            ? { backgroundColor: " #d4ffbf" }
            : { backgroundColor: "#ffced1" }
        }
      >
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">{data?.payment}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          {/* <div className="cell-number">{cellNumber}.</div> */}
          <div className="table-scroll-text">
            {data?.isActive ? "Aktiv" : "Deaktiv"}
          </div>
        </div>
      </td>
      <td>
        {/* <UpdateDeleteModal
          updateItem={updateItem}
          data={data}
          openConfirmModal={() => {}}
          profil={"company"}
          state={consultation}
          setShowDeleteModal={() => {}}
        /> */}
      </td>
    </tr>
  );
};

export default TuitionFeeCompanyCard;
